import axios from 'axios';
import store from '../redux';
import getBaseUrl from '../helpers/getBaseUrl';
import tokenParser from '../helpers/tokenParser';
import client from './client';
import users from './users';

const url = getBaseUrl();

export const authenticationService = {
    login,
    logout,
    updateToken,
    ad_validation
};

function ad_validation(email, password) {
    email = email.trim()
    let ttc_exists = email.endsWith('@ttc.kz')
    if (!ttc_exists) {
        email = `${email}@ttc.kz`
    }
    return axios({
        method: 'post',
        url: getBaseUrl() + '/api/v1/auth/',
        data: {
            email,
            password,
        },
    }).then((response) => {

        if (response.status === 200) {
            return 'Success'
        }

    }).catch(error => {

        if (error?.response?.status === 404) {
            return 'User not found'
        } else if (error?.response?.status === 403) {
            return 'AD not valid'
        }
        return 'Network error'
    })
}

function login(email) {
    email = email.trim()
    let ttc_exists = email.endsWith('@ttc.kz')
    if (!ttc_exists) {
        email = `${email}@ttc.kz`
    }
    return axios({
        method: 'post',
        url: getBaseUrl() + '/api/v1/LoginUserApi/',
        data: {
            email,
        },
    }).then((response) => {
        localStorage.setItem('token', response?.data?.access);
        localStorage.setItem('refresh', response?.data?.refresh);
        const userData = tokenParser(response?.data?.access);
        localStorage.setItem('userId', userData?.user_id);
        users.getUserById(userData?.user_id).then((response) => {
            let userResp = response?.data;
            localStorage.setItem('userData', JSON.stringify(userResp));

            let deptCode = '10333';
            try {
                if (typeof userResp?.division_profile_ver === 'string') {
                    deptCode = JSON.parse(userResp.division_profile_ver)?.code || '10333';
                } else if (userResp?.division_profile_ver?.code) {
                    deptCode = userResp.division_profile_ver.code;
                }
            } catch (e) {}
            localStorage.setItem('userDepartmentCode', deptCode);

            const role = userResp?.profile?.role ?? 1;
            localStorage.setItem('userRole', JSON.stringify(role));

            let contengent = 1;
            try {
                if (userResp?.profile?.contengent !== undefined && userResp?.profile?.contengent !== null) {
                    contengent = typeof userResp.profile.contengent === 'string' ? JSON.parse(userResp.profile.contengent) : userResp.profile.contengent;
                }
            } catch (e) {}
            localStorage.setItem('userContengent', JSON.stringify(contengent));

            store.dispatch({type: 'SAVE_USER_DATA', payload: userResp});

            if (userResp) {
                if (role !== 1 && role !== 2)
                    users.getUserList({branch_name: userResp?.profile?.branch?.name}).then(res => {
                        let json_str = JSON.stringify(res.data);
                        localStorage.setItem('all_users', json_str);
                    }).catch(() => {});
                else
                    users.getUserList().then(res => {
                        let json_str = JSON.stringify(res.data);
                        localStorage.setItem('all_users', json_str);
                    }).catch(() => {});
            } else authenticationService.logout();

        }).catch(err => {
            console.error("getUserById error: ", err);
        });

        if (userData) {
            store.dispatch({type: 'SAVE_USER_ID', payload: userData?.user_id});
        }

        updateToken(response?.data?.access);
        console.log(response?.data?.access)
        return {...response.data, userId: userData?.user_id};
    });
}

function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh');
    localStorage.removeItem('userId');
    localStorage.removeItem('all_users')
    localStorage.removeItem('userData')
    localStorage.removeItem('userRole')
    localStorage.removeItem('userContengent')
    localStorage.removeItem('userDepartmentCode')

    store.dispatch({type: 'SIGN_OUT'});
    store.dispatch({type: 'CLEAR_DATA'});
}

function updateToken(token, type = 'Bearer') {
    localStorage.setItem('token', token);
    store.dispatch({type: 'SIGN_IN'});
    client.defaults.headers['Authorization'] = type + ' ' + token;
}
